import { render } from "./step3.vue?vue&type=template&id=38455aa0&scoped=true"
import script from "./step3.vue?vue&type=script&lang=js"
export * from "./step3.vue?vue&type=script&lang=js"

import "./step3.vue?vue&type=style&index=0&id=38455aa0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38455aa0"]])

export default __exports__